import React, { useEffect } from "react";
import { Header } from "../../components/mmtrip/Header";
import { Navbar } from "../../components/mmtrip/Navbar";
import { Bookingcss } from "../../components/mmtrip/Bookingcss";
import { Smallbutton } from "../../components/mmtrip/Smallbutton";
import { Icondiv } from "../../components/mmtrip/Icondiv";
import BusinessIcon from "@mui/icons-material/Business";
import { Bigslide, TripMoney } from "../../components/mmtrip/Slidecss";
import { Box } from "@mui/material";
import {
  Hidden,
  useMediaQuery,
  useTheme,
  Grid,
  Container,
  makeStyles,
  Divider,
} from "@material-ui/core";
// import CarouselInterHoliday from "../../components/reusableComponents/CarouselInterHoliday";
import CarouselInterHoliday from "../../components/reusableComponents/CarouselInterHoliday";
import { Link, useHistory } from "react-router-dom";
import MSearchFlight from "../../form/MSearch";
import MMTForm from "../../form/MMTForm";
import { SmallBottom } from "../../components/mmtrip/SmallBottom";
import mIamge from "../../assets/images/mImage.jpg";
import {
  MultipleSlidesExample,
  BigSlidesExample,
} from "../../components/mmtrip/Slidebar";
import Footer from "../Desktop/Footer";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FlightBooking from "../../assets/images/FlightBooking.jpg";
import { useDispatch, useSelector } from "react-redux";
import {
  agentlogogetDispatch,
  walletBalanceAgentDispatch,
} from "../../reducers/UserReducer";
import {
  fareQuoteEtravSuccess,
  fetchCashback,
  fetchcoupan,
  fetchDepart,
  fetchFooterMenu,
  fetchFooterSub_Menu,
  fetchHotel,
  fetchlogo,
  fetchOrigin,
  searchSuccess,
  searchSuccessEtrav,
} from "../../reducers/HomeReducer";
import {
  setSelectedDepart,
  setSelectedOrigin,
  toggleBPNRModal,
  toggleRegisterModal,
  toggleRegisterTravellerModal,
} from "../../reducers/UiReducer";
import RegisterAgentModal from "../../components/reusableComponents/RegisterAgentModal";
import RegisterTravellerModal from "../../components/reusableComponents/RegisterTravellerModal";
import LoaderModal from "../../components/reusableComponents/LoaderModal";
import HomeLoader from "../../components/reusableComponents/HomeLoader";
import HeaderSection from "../../components/reusableComponents/HeaderSection";
const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    paddingRight: 15,
    paddingLeft: 15,
    marginRight: "auto",
    marginLeft: "auto",
  },
  header: {
    background: "#fff",
    boxShadow: "0px 0px 10px rgb(0 0 0 / 5%)",
  },
  back: {
    backgroundImage: `url(${mIamge})`,

    // backgroundPosition: '1px -241px',
    zIndex: 0,
    backgroundAttachment: "fixed",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    transition: "background-image 300ms ease-in 200ms",
  },
}));
const LandingPage = () => {
  const { agentlogin, loadinguser } = useSelector((state) => state.user);
  const classes = useStyles();
  const dt = new Date();
	const [value, setValue] = React.useState([
		new Date(),
		dt.setDate(dt.getDate() + 3),
	]);
  const { origin, depart,hotel } = useSelector((state) => state.home);
  const theme = useTheme();
  const history = useHistory();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));
  window.onscroll = () => {
    let loginForm = document.querySelector(".login-form");
    let navbar = document.querySelector(".navbar");
    navbar.classList.remove("active");
    loginForm.classList.remove("active");
  };
  var mystring = "Bangalore,BLR-India";
  var splits = mystring.split(",");
  console.log("first", splits); // output: this
  console.log("first", splits[1].split("-")); // output: this
  // window.onscroll = () => {
  //   let loginForm2 = document.querySelector('.login-form2');
  //   let navbar2 = document.querySelector('.navbar2');
  //   navbar2.classList.remove('active2');
  //   loginForm2.classList.remove('active2');

  // };
  const convert = (str) => {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  };
  const handlePopup = () => {
    const popup = document.getElementById("popup");
    popup.classList.toggle("active");
  };
  const dispatch = useDispatch();
  useEffect(() => {
    let form = {};
    dispatch(fetchCashback(form));
    dispatch(fetchFooterMenu(form));
    dispatch(fetchFooterSub_Menu(form));
    dispatch(fetchOrigin(form));
    dispatch(fetchDepart(form));
    dispatch(fetchlogo(form));
    dispatch(searchSuccess(null));
    dispatch(searchSuccessEtrav(null));
    dispatch(fetchHotel(form));
    dispatch(fetchcoupan(form));
    dispatch(toggleBPNRModal(false));
    dispatch(fareQuoteEtravSuccess(null))
    if (agentlogin && agentlogin.status === 200) {
      let logodata = {
        agent_id: agentlogin && agentlogin.result.result.id,
      };
      dispatch(agentlogogetDispatch(logodata));
      // let walletform = {
      // 	userEmail: agentlogin && agentlogin.result.result.email,
      // 	userId: ,
      // };
      dispatch(
        walletBalanceAgentDispatch(
          agentlogin && agentlogin.result.result.email,
          agentlogin && agentlogin.result.result.id
        )
      );
    }
  }, []);
  return (
    <div>
      {/* <Header /> */}.
      <Box
        className={classes.container}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box style={{ paddingBottom: 4.5, paddingTop: 4.5 }}>
          <i class="fas fa-blender-phone"></i>
          <span style={{ color: "#065999", fontSize: 13 }}>1800 8890 743 </span>
          <span style={{ display: "inline-block", width: "1px" }}></span>
          <i class="fa fa-fw fa-envelope"></i>
          <span style={{ color: "#065999", fontSize: 13 }}>info@xyz.com</span>
        </Box>
      </Box>
      <HeaderSection id={1} />
      {/* <header
        className={classes.header}
        style={{ paddingLeft: 20, paddingRight: 20 }}
      >
        <Hidden only={["xs"]}>
          {" "}
          <Box
            className={classes.container}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box display="flex" alignItems="center">
              <img
                src="https://nitish.musafirbazar.com/static/logo.png"
                // src={fly365}
                style={{ height: 100,width:176 }}
                // style={{ height: 80,width:80 }}
              />
            </Box>
            <Box>
              <i
                class="fas fa-plane-departure"
                style={{ color: "blue", marginRight: 5 }}
              ></i>
              <span style={{ color: "#0A95FF" }}>Flight</span>
              <span style={{ color: "#0A95FF", marginLeft: 20 }}>
                My Booking
              </span>
            </Box>
          </Box>
        </Hidden>

        <Hidden only={["lg", "xl", "sm", "md"]}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <img
              src="https://nitish.musafirbazar.com/static/logo.png"
              style={{ height: 100,width:176 }}
            />
            <div className="icons">
              <div
                className="fas fa-bars"
                id="menu-btn"
                onClick={() => {
                  // let navbar = document.querySelector('.navbar');
                  // navbar.classList.toggle('active');
                  // navbar.classList.add('active');
                }}
              ></div>
            </div>
          </Box>
        </Hidden>
      </header> */}
      {/* <div
					style={{
						position: 'absolute',
						// top: '0px',
						left: '0px',
						height: '100%',
						width: '100%',
						zIndex: 1,
						background: 'rgb(26, 43, 72)',
						opacity: 0.3,
					}}></div> */}
      <div style={{ position: "relative" }}>
        {/* <div
					style={{
						position: 'absolute',
						top: '0px',
						left: '0px',
						height: '100%',
						width: '100%',
						zIndex: 1,
						background: 'rgb(26, 43, 72)',
						opacity: 0.3,
					}}></div> */}
        <section
          onClick={() => {
            let loginForm = document.querySelector(".login-form");
            let navbar = document.querySelector(".navbar");
            navbar.classList.remove("active");
            loginForm.classList.remove("active");
          }}
          className={classes.back}
          style={{ height: matches ? 800 : 500 }}
          // data-aos='zoom-in'
        >
          {/* <MSearch /> */}
          {/* <SearchFlight/> */}
          <MSearchFlight />
          {/* <Box display='flex'>
						<div style={{ marginTop: 10, background: '#263a4a' }}>
							<p
								style={{
									color: 'red',
									fontSize: 16,
									fontWeight: 600,
									marginLeft: 5,
								}}>
								HotDeals
							</p>
						</div>
						<marquee>
							<div style={{ marginTop: 10, background: '#263a4a' }}>
								<span style={{ marginLeft: 10, color: 'white' }}>
									E SINGAPORE AIRLINE @4200
								</span>
								<span style={{ marginLeft: 10, color: 'white' }}>|</span>
								<span style={{ marginLeft: 10, color: 'white' }}>
									E SINGAPORE AIRLINE @4200
								</span>
								<span style={{ marginLeft: 10, color: 'white' }}>|</span>
								<span style={{ marginLeft: 10, color: 'white' }}>
									E SINGAPORE AIRLINE @4200
								</span>
								<span style={{ marginLeft: 10, color: 'white' }}>|</span>
								<span style={{ marginLeft: 10, color: 'white' }}>
									E SINGAPORE AIRLINE @4200
								</span>
								<span style={{ marginLeft: 10, color: 'white' }}>|</span>
								<span style={{ marginLeft: 10, color: 'white' }}>
									E SINGAPORE AIRLINE @4200
								</span>
								<span style={{ marginLeft: 10, color: 'white' }}>|</span>
							</div>
						</marquee>
					</Box> */}
        </section>
      </div>
      {/* <label>{t('Search')}</label> */}
      {/* <Box style={{ padding: 20 }}>
        <h2 style={{color: '#0c2f54',
        
    fontFamily: '"Poppins", sans-serif'}}>{t("hotel")}</h2>
        <span style={{fontFamily: '"Poppins", sans-serif',fontSize:16}}>Enjoy unforgettable experiences in dream hotels worldwide</span>
       <div style={{marginTop:10}}>
	   <Carousel />
	   </div>
      </Box> */}
      {/* <Navbar style={{height:matches?873:500}}>
        <div className="topdiv">
         
           
          <Link to="/">
            <img
            style={{height:155,width:200}}
              className="mmtlogo"
              src={
                'https://nitish.musafirbazar.com/static/logo.png'
              }
              alt="Logo"
            />
          </Link>
          <div className="login">
          </div>
          <Hidden only={['xs']}>
          <Smallbutton>
            <div className="smallbuttonpic">
              <BusinessIcon></BusinessIcon>
            </div>
            <div>
              <h4>My Trips</h4>
              <p>Manage your Bookings</p>
            </div>
          </Smallbutton>
          </Hidden>
          <Smallbutton>
            <div className="smallbuttonpic" style={{display:'flex',alignItems:'center'}}>
            <i class="fa fa-user" ></i>
            <span style={{marginLeft:10,cursor:'pointer'}} onClick={()=>dispatch(toggleRegisterTravellerModal(true))}>Login</span>
            <span style={{marginLeft:10}}>/</span>
            <span style={{marginLeft:10,cursor:'pointer'}} onClick={()=>dispatch(toggleRegisterModal(true))}>SignUp</span>
            </div>
            
          </Smallbutton>
        </div>
        <Bookingcss>
          <Icondiv className="icondiv"></Icondiv>
          
         
          <MMTForm/>
        </Bookingcss>
       
      </Navbar> */}
      <div
        style={{ background: "#ebe7e7", paddingTop: "0px", paddingBottom: 50 }}
      >
        <Hidden only={["xs"]}>
          <SmallBottom />
        </Hidden>
        <div style={{ width: "90%", margin: "auto" }}>
          <MultipleSlidesExample />
        </div>
        <Bigslide>
          <div className="supreoffers">
            <h1 style={{ fontSize: matches ? 25 : 40 }}>Super Offers</h1>
            <div>
              <h3 style={{ fontSize: matches ? 14 : 24 }}>ALL OFFERS</h3>
              {/* <h3>BANK OFFERS</h3>
              <h3>DOMESTIC FLIGHTS</h3>
              <h3>MORE</h3> */}
            </div>
          </div>
          <BigSlidesExample className="bigslideex"></BigSlidesExample>
        </Bigslide>
        <TripMoney>
          <Grid
            container
            className="maindiv"
            style={{ height: matches ? 500 : 100 }}
          >
            <Grid item xs={12} lg={4}>
              {" "}
              <div id="div2" style={{ borderColor: "#e47dad" }}>
                <img
                  src="https://www.tripmoney.com/ext/static/TravelLoan/travelLoan.png"
                  alt=""
                />
                <div>
                  <div className="spa1n"></div>
                  <h3>Personal loan</h3>
                  <p>Get upto ₹1 lakh for booking flights, hotels & more.</p>
                </div>
                <div className="span2"></div>
              </div>
            </Grid>
            <Grid item xs={12} lg={4}>
              {" "}
              <div id="div2" style={{ borderColor: "#dde47d" }}>
                <img
                  src="https://www.tripmoney.com/ext/static/credit-card/cc@3x.png"
                  alt=""
                />
                <div>
                  <div className="spa1n"></div>
                  <h3>Credit cards</h3>
                  <p>Get instant approval & unmatched privileges.</p>
                </div>
                <div className="span2"></div>
              </div>
            </Grid>
            <Grid item xs={12} lg={4}>
              <div>
                <div id="div2" style={{ borderColor: "#7dbee4" }}>
                  <img
                    src="https://www.tripmoney.com/ext/static/PL/pl.png"
                    alt=""
                  />
                  <div>
                    <div className="spa1n"></div>
                    <h3>Travel loan</h3>
                    <p>Get approval for ₹30,00,000 at low interest rates.</p>
                  </div>
                  <div className="span2"></div>
                </div>
              </div>
            </Grid>
          </Grid>
        </TripMoney>
        <div style={{ padding: 20 }}>
          <h2
            style={{
              color: "#0c2f54",
              fontWeight: 600,
              fontFamily: '"Poppins", sans-serif',
            }}
          >
            Featured Deals
          </h2>
          <p style={{ color: "#0c2f54" }}>Get the Best Deals & Discounts</p>
        </div>
        <Grid container>
          <Grid item xs={12} sm={6} lg={6}>
            <img
              src={depart&&depart?.result[0].image}
              style={{ width: "90%", marginLeft: 20 }}
            ></img>
          </Grid>
          <Grid item xs={12} sm={6} lg={6}>
            <img
              src={depart&&depart?.result[1].image}
              style={{
                width: "90%",
                marginLeft: matches ? 20 : "",
                marginTop: matches ? 20 : "",
              }}
            ></img>
          </Grid>
        </Grid>
        <div
          style={{
            padding: 20,
            boxShadow: "0px 0px 50px -35px rgb(0 0 0 / 40%)",
          }}
        >
          <h1
            style={{
              textAlign: "center",
              fontWeight: 600,
              color: "#0c2f54",
              fontFamily: '"Poppins", sans-serif',
            }}
          >
            Start your travel planning here
          </h1>
          <Container style={{ marginTop: 20 }}>
            <Grid container spacing={2}>
              {origin &&
                origin?.result?.map((i,index) => {
                  return (
                    <Grid item xs={12} lg={4} alignItems="center">
                      <Box justifyContent="space-between" display="flex">
                        <h3>
                          {/* {i.destination.split(",")[0]} */}
                          {i.destination.split(",")[1].split("-")[0]}
                          </h3>

                        <ExpandMoreIcon />
                      </Box>
                      <Box>
                        <span
                          style={{
                            cursor: "pointer",
                            color: "black",
                            marginLeft: index === 0 ? 0 : 5,
                          }}
                          onClick={() => {
                            let formData = {
                              AdultCount: 1,
                              ChildCount: 0,
                              InfantCount: 0,
                              DirectFlight: false,
                              OneStopFlight: false,
                              JourneyType: 1,
                              PreferredAirlines: null,
                              Segments: [
                                {
                                  Origin: i.destination.split(",")[1].split("-")[0],
                                  Destination: i.first.split(",")[1].split("-")[0],
                                  FlightCabinClass: 1,
                                  PreferredDepartureTime: convert(dt.setDate(dt.getDate() + 7)),
                                },
                              ],
                              Sources: "WEB",
                              agent_id: agentlogin
                                ? agentlogin.status === 200
                                  ? agentlogin?.result.result.id
                                  : 0
                                : 0,
                              // agent_id: agentlogin&&agentlogin.status===200 ? agentlogin && agentlogin.result.result.id : 0,
                            };
                            history.push({
                              pathname: `/oneway/${i.destination.split(",")[1].split("-")[0]}/${i.first.split(",")[1].split("-")[0]}/${convert(dt.setDate(dt.getDate() + 7))}`,
                              state: {
                                body: formData,
                                OriginO: convert(dt.setDate(dt.getDate() + 7)),
                              },
                            });
                            let originData = {
                              airport_code: i.destination.split(",")[1].split("-")[0],
                              airport_name: "Chhatrapati Shivaji Intl.",
                              city_name: i.destination.split(",")[0],
                              country_name: i.destination.split(",")[1].split("-")[1],
                              country_code: "IN",
                            };
                            let departData = {
                              airport_code: i.first.split(",")[1].split("-")[0],
                              airport_name: "Chhatrapati Shivaji Intl.",
                              city_name: i.first.split(",")[0],
                              country_name: i.first.split(",")[1].split("-")[1],
                              country_code: "IN",
                            };
                            dispatch(setSelectedOrigin(originData));
                            dispatch(setSelectedDepart(departData));
                          }}
                        >
                          {i.first.split(",")[0]}
                        </span>
                        <span
                          style={{
                            cursor: "pointer",
                            color: "black",
                            marginLeft:  5,
                          }}
                          onClick={() => {
                            let formData = {
                              AdultCount: 1,
                              ChildCount: 0,
                              InfantCount: 0,
                              DirectFlight: false,
                              OneStopFlight: false,
                              JourneyType: 1,
                              PreferredAirlines: null,
                              Segments: [
                                {
                                  Origin: i.destination.split(",")[1].split("-")[0],
                                  Destination: i.second.split(",")[1].split("-")[0],
                                  FlightCabinClass: 1,
                                  PreferredDepartureTime: convert(dt.setDate(dt.getDate() + 7)),
                                },
                              ],
                              Sources: "WEB",
                              agent_id: agentlogin
                                ? agentlogin.status === 200
                                  ? agentlogin?.result.result.id
                                  : 0
                                : 0,
                              // agent_id: agentlogin&&agentlogin.status===200 ? agentlogin && agentlogin.result.result.id : 0,
                            };
                            history.push({
                              pathname: `/oneway/${i.destination.split(",")[1].split("-")[0]}/${i.second.split(",")[1].split("-")[0]}/${convert(dt.setDate(dt.getDate() + 7))}`,
                              state: {
                                body: formData,
                                OriginO: convert(dt.setDate(dt.getDate() + 7)),
                              },
                            });
                            let originData = {
                              airport_code: i.destination.split(",")[1].split("-")[0],
                              airport_name: "Chhatrapati Shivaji Intl.",
                              city_name: i.destination.split(",")[0],
                              country_name: i.destination.split(",")[1].split("-")[1],
                              country_code: "IN",
                            };
                            let departData = {
                              airport_code: i.second.split(",")[1].split("-")[0],
                              airport_name: "Chhatrapati Shivaji Intl.",
                              city_name: i.second.split(",")[0],
                              country_name: i.second.split(",")[1].split("-")[1],
                              country_code: "IN",
                            };
                            dispatch(setSelectedOrigin(originData));
                            dispatch(setSelectedDepart(departData));
                          }}
                        >
                          {i.second.split(",")[0]}
                        </span>
                        <span
                          style={{
                            cursor: "pointer",
                            color: "black",
                            marginLeft:  5,
                          }}
                          onClick={() => {
                            let formData = {
                              AdultCount: 1,
                              ChildCount: 0,
                              InfantCount: 0,
                              DirectFlight: false,
                              OneStopFlight: false,
                              JourneyType: 1,
                              PreferredAirlines: null,
                              Segments: [
                                {
                                  Origin: i.destination.split(",")[1].split("-")[0],
                                  Destination: i.third.split(",")[1].split("-")[0],
                                  FlightCabinClass: 1,
                                  PreferredDepartureTime: convert(dt.setDate(dt.getDate() + 7)),
                                },
                              ],
                              Sources: "WEB",
                              agent_id: agentlogin
                                ? agentlogin.status === 200
                                  ? agentlogin?.result.result.id
                                  : 0
                                : 0,
                              // agent_id: agentlogin&&agentlogin.status===200 ? agentlogin && agentlogin.result.result.id : 0,
                            };
                            history.push({
                              pathname: `/oneway/${i.destination.split(",")[1].split("-")[0]}/${i.third.split(",")[1].split("-")[0]}/${convert(dt.setDate(dt.getDate() + 7))}`,
                              state: {
                                body: formData,
                                OriginO: convert(dt.setDate(dt.getDate() + 7)),
                              },
                            });
                            let originData = {
                              airport_code: i.destination.split(",")[1].split("-")[0],
                              airport_name: "Chhatrapati Shivaji Intl.",
                              city_name: i.destination.split(",")[0],
                              country_name: i.destination.split(",")[1].split("-")[1],
                              country_code: "IN",
                            };
                            let departData = {
                              airport_code: i.third.split(",")[1].split("-")[0],
                              airport_name: "Chhatrapati Shivaji Intl.",
                              city_name: i.third.split(",")[0],
                              country_name: i.third.split(",")[1].split("-")[1],
                              country_code: "IN",
                            };
                            dispatch(setSelectedOrigin(originData));
                            dispatch(setSelectedDepart(departData));
                          }}
                        >
                          {i.third.split(",")[0]}
                        </span>
                        <span
                          style={{
                            cursor: "pointer",
                            color: "black",
                            marginLeft:  5,
                          }}
                          onClick={() => {
                            let formData = {
                              AdultCount: 1,
                              ChildCount: 0,
                              InfantCount: 0,
                              DirectFlight: false,
                              OneStopFlight: false,
                              JourneyType: 1,
                              PreferredAirlines: null,
                              Segments: [
                                {
                                  Origin: i.destination.split(",")[1].split("-")[0],
                                  Destination: i.fourth.split(",")[1].split("-")[0],
                                  FlightCabinClass: 1,
                                  PreferredDepartureTime: convert(dt.setDate(dt.getDate() + 7)),
                                },
                              ],
                              Sources: "WEB",
                              agent_id: agentlogin
                                ? agentlogin.status === 200
                                  ? agentlogin?.result.result.id
                                  : 0
                                : 0,
                              // agent_id: agentlogin&&agentlogin.status===200 ? agentlogin && agentlogin.result.result.id : 0,
                            };
                            history.push({
                              pathname: `/oneway/${i.destination.split(",")[1].split("-")[0]}/${i.fourth.split(",")[1].split("-")[0]}/${convert(dt.setDate(dt.getDate() + 7))}`,
                              state: {
                                body: formData,
                                OriginO: convert(dt.setDate(dt.getDate() + 7)),
                              },
                            });
                            let originData = {
                              airport_code: i.destination.split(",")[1].split("-")[0],
                              airport_name: "Chhatrapati Shivaji Intl.",
                              city_name: i.destination.split(",")[0],
                              country_name: i.destination.split(",")[1].split("-")[1],
                              country_code: "IN",
                            };
                            let departData = {
                              airport_code: i.fourth.split(",")[1].split("-")[0],
                              airport_name: "Chhatrapati Shivaji Intl.",
                              city_name: i.fourth.split(",")[0],
                              country_name: i.fourth.split(",")[1].split("-")[1],
                              country_code: "IN",
                            };
                            dispatch(setSelectedOrigin(originData));
                            dispatch(setSelectedDepart(departData));
                          }}
                        >
                          {i.fourth.split(",")[0]}
                        </span>
                      </Box>
                      <Divider style={{ marginTop: 10 }} />
                    </Grid>
                  );
                })}
            </Grid>
          </Container>
        </div>

        {/* <Bigslide>
          <Grid container>
            <Grid item xs={12} lg={4}><Box>
            <Box style={{paddingLeft:50,paddingTop:10}}>
            <h1>Download App Now !</h1>
            <span>Get India's #1 travel super app, join 100 Million+ happy travellers!</span>
           
            </Box>
            <Box style={{paddingLeft:50,marginTop:20}}>
                <span>MORE WAYS TO GET THE APP</span><br></br>
            <img style={{height:60,marginTop:20}} src='https://tz-mag-media.s3.ap-southeast-1.amazonaws.com/wp-content/uploads/2018/05/10182849/google-play-download-android-app-logo-png-transparent.png'/>

            </Box>
            </Box></Grid>
           <Hidden only={['xs']}>
           <Grid item xs={12} lg={8}>  <Box style={{padding:140,display:'flex'}}>
                 <span style={{border:'1px solid grey',padding:7,borderRight:'hidden'}}>
                    <img src='https://imgak.mmtcdn.com/pwa_v3/pwa_mmt_ui_assets/in_v2.webp' style={{height:20}}/>
                    <span>+91</span>
                </span>
               
            <form >
               
  <input type="text" id="fname" name="fname" placeholder="Enter Your Mobile Number" style={{border: '1px solid grey',
    padding: '10px',borderLeft:'hidden'}}/>
  
  <input type="submit" value="GET APP LINK" style={{border: '1px solid blue',
    background: 'white',
    color: 'blue',
    padding: '10px'}}/>
</form>
            </Box></Grid>
           </Hidden>
          </Grid>
            
        
        </Bigslide> */}
        {/* <Bottom /> */}
      </div>
      <Container>
        {/* <img
          src="https://www.marinersforex.com/img/Rassia-MF.jpg"
          style={{ width: "100%" }}
        ></img> */}
        <h2 style={{ fontFamily: '"Poppins", sans-serif', color: "#0c2f54" }}>
          Affordable Package
        </h2>
        <p>
          Explore a variety of holiday tour packages and create lasting memories
        </p>
        <CarouselInterHoliday />
      </Container>
      <Footer />
      <RegisterAgentModal />
      <RegisterTravellerModal />
      {loadinguser ? <LoaderModal /> : ""}
      {/* {true ?       <HomeLoader/> : ''} */}
    </div>
  );
};

export default LandingPage;
